import React, { useState } from 'react'
import { BreadcrumbView } from '../../context/breadcrumb.context'
import { EmptyState } from '../empty-state/empty-state'
import { IconSearch } from '../icon/icon'

// A record that isn't there -- deleted, another organization's, or a link
// with a wrong id -- used to show its section's crumb over an empty form with
// a live Update button (audit F19). The crumb names what isn't there
// ("Group not found") and the page says so instead of the form.

// The answers that mean there is no such record here: not found, gone, or
// not this organization's to see.
export const isMissing = error => {
  const status = error && (error.status || (error.response && error.response.status))
  return status === 404 || status === 403 || status === 410
}

export const notFoundText = noun => `${noun.charAt(0).toUpperCase()}${noun.slice(1)} not found`

// The page's body when its record isn't there. `back`: { label, to }.
export const RecordNotFound = ({ noun, back }) =>
  <div className="p-3">
    <EmptyState
      Icon={IconSearch}
      title={notFoundText(noun)}
      message={`There is no such ${noun} here. It may have been deleted, it may belong to another organization, or the link may be wrong.`}
      action={back ? { label: back.label, to: back.to } : undefined}
    />
  </div>

// A record page's BreadcrumbView: as BreadcrumbView, with the record's
// `noun` and the way `back`. onPath loads the record; when that answers that
// the record isn't there, the crumb and the page say so. Any other failure
// leaves the page as it was: its form keeps the error (api-new's state) and
// the admin's error handling shows it. Either way the rejection stops here,
// where it used to surface as an uncaught one (the dev server's red overlay).
export const RecordView = ({ noun, back, onPath, text, children, ...props }) => {
  const [missing, setMissing] = useState(false)

  const handlePath = async () => {
    try {
      const result = await onPath()
      setMissing(false)
      return result
    } catch (error) {
      if (isMissing(error)) setMissing(true)
      return undefined
    }
  }

  return (
    <BreadcrumbView {...props} text={missing ? notFoundText(noun) : text} onPath={onPath ? handlePath : undefined}>
      {missing ? <RecordNotFound noun={noun} back={back} /> : children}
    </BreadcrumbView>
  )
}
